import React from "react";
import { Box } from "@mui/material";
import { Card } from "./Card";

export interface FiltersCardProps {
  children: React.ReactNode;
}

/**
 * Carte contenant la barre de recherche et les filtres (design system).
 * Padding et disposition uniformes sur toutes les pages liste.
 */
export function FiltersCard({ children }: FiltersCardProps): JSX.Element {
  return (
    <Card sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", lg: "row" },
          gap: 2,
          flexWrap: "wrap",
          alignItems: { xs: "stretch", lg: "center" },
        }}
      >
        {children}
      </Box>
    </Card>
  );
}
